/** Split `text` on `separator`, trim every part and drop the empty ones. */
export const splitTrimmed = (text, separator = '\n') =>
  String(text || '').split(separator).map((part) => part.trim()).filter(Boolean);
